import { useState } from "react";
import { Play } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { GALLERY } from "../config";
import { Reveal, Page } from "../components/Reveal";
import PageHero from "../components/PageHero";
import Lightbox from "../components/Lightbox";
import SEO from "../components/SEO";

const Galeria = () => {
  const { t } = useLang();
  const [tag, setTag] = useState("all");
  const [lightbox, setLightbox] = useState(null);

  const tags = ["all", "coloracao", "balayage", "progressiva", "cortes"];
  const items = GALLERY.filter((g) => tag === "all" || g.tag === tag).map((g) => ({
    ...g,
    caption: t.galleryPage.captions[g.key],
  }));

  return (
    <Page>
      <SEO title={t.meta.galeria.title} desc={t.meta.galeria.desc} />
      <PageHero eyebrow={t.galleryPage.eyebrow} title={t.galleryPage.title} desc={t.galleryPage.p} testid="gallery-hero" />

      <section className="bg-cream pb-28 sm:pb-36" data-testid="gallery-grid">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="mb-12 flex flex-wrap gap-2.5" role="tablist" aria-label="Filtros da galeria">
            {tags.map((tg) => (
              <button
                key={tg}
                role="tab"
                aria-selected={tag === tg}
                data-testid={`gallery-filter-${tg}`}
                onClick={() => { setTag(tg); setLightbox(null); }}
                className={`rounded-full px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.16em] transition-all duration-300 ${
                  tag === tg
                    ? "bg-rosedeep text-white shadow-lg"
                    : "border border-blush bg-white text-ink/60 hover:border-rose/60 hover:text-ink"
                }`}
              >
                {t.galleryPage.tags[tg]}
              </button>
            ))}
          </div>

          <div className="columns-2 gap-5 lg:columns-3 [&>*]:mb-5">
            {items.map((item, i) => (
              <button
                key={`${item.key}-${i}`}
                onClick={() => setLightbox(i)}
                data-testid={`gallery-item-${item.key}-${i}`}
                className="img-zoom card-lift relative block w-full break-inside-avoid overflow-hidden rounded-3xl ring-1 ring-blush transition-shadow hover:ring-rose/50"
              >
                {item.video ? (
                  <>
                    <video
                      src={item.video}
                      poster={item.poster}
                      muted
                      loop
                      autoPlay
                      playsInline
                      preload="metadata"
                      className="w-full object-cover"
                      aria-label={item.caption}
                    />
                    <span className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-ink/55 text-white backdrop-blur-sm">
                      <Play className="h-4 w-4 fill-current" />
                    </span>
                  </>
                ) : (
                  <img src={item.img} alt={item.caption} className="w-full object-cover" loading="lazy" />
                )}
                <span className="sr-only">{item.caption}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Lightbox
        items={items}
        index={lightbox}
        onClose={() => setLightbox(null)}
        onNav={(dir) => items.length > 0 && setLightbox((i) => (i + dir + items.length) % items.length)}
      />
    </Page>
  );
};

export default Galeria;
